import { render } from "./ListDemo.vue?vue&type=template&id=4944e982&scoped=true"
import script from "./ListDemo.vue?vue&type=script&lang=js"
export * from "./ListDemo.vue?vue&type=script&lang=js"

import "./ListDemo.vue?vue&type=style&index=0&id=4944e982&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4944e982"]])

export default __exports__